import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Contact() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("contact.title", "Get in Touch")}
      subtitle={t("contact.subtitle", "We'd love to hear from you")}
    >
      <div className="space-y-8">
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("contact.methodsTitle", "Contact Methods")}
          </h2>
          <div className="space-y-6">
            <div className="rounded-lg border border-slate-700 bg-slate-800/30 p-6">
              <h3 className="mb-2 text-lg font-semibold text-white">
                📧 {t("contact.emailTitle", "Email")}
              </h3>
              <p className="text-slate-300">
                <a
                  href="mailto:hello@partybuddy.app"
                  className="text-blue-400 transition hover:text-blue-300"
                >
                  hello@partybuddy.app
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-400">
                {t("contact.emailText", "General inquiries, feedback, and partnership opportunities")}
              </p>
            </div>

            <div className="rounded-lg border border-slate-700 bg-slate-800/30 p-6">
              <h3 className="mb-2 text-lg font-semibold text-white">
                📱 Instagram
              </h3>
              <p className="text-slate-300">
                <a
                  href="https://instagram.com/partybuddy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 transition hover:text-blue-300"
                >
                  @partybuddy
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-400">
                {t("contact.instagramText", "Latest events, community highlights, and behind-the-scenes")}
              </p>
            </div>

            <div className="rounded-lg border border-slate-700 bg-slate-800/30 p-6">
              <h3 className="mb-2 text-lg font-semibold text-white">
                f Facebook
              </h3>
              <p className="text-slate-300">
                <a
                  href="https://facebook.com/partybuddy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-400 transition hover:text-blue-300"
                >
                  PartyBuddy Community
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-400">
                {t("contact.facebookText", "Event discussions and community updates")}
              </p>
            </div>

            <div className="rounded-lg border border-slate-700 bg-slate-800/30 p-6">
              <h3 className="mb-2 text-lg font-semibold text-white">
                💼 {t("contact.businessTitle", "Business Inquiries")}
              </h3>
              <p className="text-slate-300">
                <a
                  href="mailto:business@partybuddy.app"
                  className="text-blue-400 transition hover:text-blue-300"
                >
                  business@partybuddy.app
                </a>
              </p>
              <p className="mt-2 text-sm text-slate-400">
                {t("contact.businessText", "Partnerships, sponsorships, and enterprise solutions")}
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("contact.responseTitle", "Average Response Time")}
          </h2>
          <p className="text-slate-300">
            {t(
              "contact.responseText",
              "We typically respond to inquiries within 24-48 hours. For urgent matters, please reach out via Instagram or Facebook."
            )}
          </p>
        </section>
      </div>
    </PageLayout>
  );
}

export default Contact;
